/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const textCardStyle = {
  paper: {
    padding: "1rem",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  boxHeading: {
    textAlign: "center",
    fontSize: "1.5rem",
  },
  default: {
    color: "text.primary",
  },
  primary: {
    color: "primary.main",
  },
  boldText: {
    fontWeight: 500,
    textAlign: "center",
    marginTop: "1rem",
  },
  center: {
    textAlign: "center",
  },
  left: {
    textAlign: "left",
  },
};

export default textCardStyle;
